import { Popover, PopoverProps } from '@mui/material'
import React from 'react'
import { PopoverContentWithResizeObserver } from '../../../popoverContentWithResizeObserver/popoverContentWithResizeObserver.index';
import { EscalationConfirm } from './components/escalationConfirm/escalationConfirm.index';

export const EscalationPopover: React.FC<{
    actionRef: React.RefObject<{ updatePosition: () => void }>;
    open: boolean;
    anchorEl: HTMLElement | null;
    onClose: () => void;
    anchorOrigin: PopoverProps['anchorOrigin'];
    transformOrigin: PopoverProps['transformOrigin'];
    id?: string;
    confirmProps: {
        title: string;
        placeholderText: string;
        onConfirm: (formData: FormData) => void;
        onCancel: () => void;
        updateStatus?: boolean
    };
}> = ({ actionRef, open, anchorEl, onClose, anchorOrigin, transformOrigin, id, confirmProps }) => {
    return (
        <Popover
            action={actionRef}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
        >
            <PopoverContentWithResizeObserver actionRef={actionRef} open={open}>
                <EscalationConfirm
                    title={confirmProps.title}
                    placeholderText={confirmProps.placeholderText}
                    onConfirm={confirmProps.onConfirm}
                    onCancel={confirmProps.onCancel}
                    updateStatus={confirmProps.updateStatus}
                />
            </PopoverContentWithResizeObserver>
        </Popover>
    )
}
